import {createFileRoute} from '@tanstack/react-router';
import CustomizeExperiencePage from '@features/customize-experience/page';

export const Route = createFileRoute('/customize-experience')({
  component: CustomizeExperiencePage,
});
